module.exports = __webpack_public_path__ + "static/media/banner2.004edf9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner2.jpg
// module id = 333
// module chunks = 0